import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Footer from './components/Footer';
import AboutSection from './components/AboutSection';
import PrivacyPolicySaitruptiCabs from './pages/PrivacyPolicy';
import TermsConditionsSaitruptiCabs from './pages/TermsConditions';
import ServicesSection from './pages/ServicesSection';
import Packages from './pages/Packages';
import OurFleet from './pages/OurFleet';
import Booking from './pages/Booking';
import GallerySection from './pages/Gallery';
import ContactDetails from './pages/ContactDetails';
import Enquiry from './pages/Enquiry';
import Punetomumbaicabs from './pages/Pune to Mumbai Cab';
import Punetomumbaiairportcabs from './pages/Pune to Mumbai Airport Cab';
import ScrollToTop from './components/ScrollToTop';
import Punetomumbaiinternatinalairport from './pages/Pune to Mumbai International Airport Cab';
import Punetomumbaionewaycabs from './pages/Pune to Mumbai One Way Cab';
import Punemumbaicarhire from './pages/Pune Mumbai Car Hire';
import Punetomumbaitaxifare from './pages/Pune to Mumbai Taxi Fare';
import Punetomumbaionlinecabbooking from './pages/Pune to Mumbai Online Cab Booking';
import Pimprichichwadtomumbaicab from './pages/Pimpri Chinchwad to Mumbai Cab';
import Banertomumbaicabs from './pages/Baner to Mumbai Cabs';
import Hinjewaditomumbaicabs from './pages/Hinjewadi to Mumbai Cab';
import Pimplesaudagartomumbai from './pages/Pimple Saudagar to Mumbai Cab Service';
import Wakadtomumbaicabs from './pages/Wakad to Mumbai Cab';
import HAdapsartomumbaicab from './pages/Hadapsar to Mumbai Cab';
import Kalyaninagartomumbaitaxi from './pages/Kalyani Nagar to Mumbai Taxi';
import Koregaonparktomumbaicabs from './pages/Koregaon Park to Mumbai Cab';
import Kothrudtomumbaicabs from './pages/Kothrud to Mumbai Cab';
import Kharaditomumbaicabs from './pages/Kharadi to Mumbai Cab';
import Shivajinagartomumbaicabs from './pages/Shivajinagar to Mumbai Cab';
import Punetomumbaiertigacabs from './pages/Pune to Mumbai Ertiga Cab';
import Punetomumbaiinnovacrystacabs from './pages/Pune to Mumbai Innova Crysta Cab';
import Punetomumbaisedancabs from './pages/Pune to Mumbai Sedan Cab';
import Kondhwatomumbaicabs from './pages/Kondhwa to Mumbai Cab';
import Vimannagartomumbaicabs from './pages/Viman Nagar to Mumbai Cabs';
import Katrajtomumbaicabservice from './pages/Katraj to Mumbai Cab Service';
import Punestationtomumbaicabservice from './pages/Pune Station to Mumbai Cabs Service';
import Punetofivejyotilingadarshancabs from './pages/Pune to 5 Jyotirlinga Darshan Cab';
import Punetoshirdicabs from './pages/Pune to Shirdi Cab';
import Punetoshirdicabfare from './pages/Pune to Shirdi Cab Fare';
import Puneairportshirdicabservice from './pages/Pune Airport to Shirdi Cab Service';
import Punetopandharpurcab from './pages/Pune to Pandharpur Cab';
import Punetoaurangabadcabs from './pages/Pune to Aurangabad Cab';
import Navimumbaitopunecabs from './pages/Navi Mumbai to Pune Cab';
import Mumbaiairporttopunecitycab from './pages/Mumbai Airport to Pune City Cab';
import Swiftdzireonrentinpune from './pages/Swift Dzire On Rent in Pune';
import Mumbaitopunedailycab from './pages/Mumbai to Pune Daily Cab';
import Mumbaitopuneonlinecabs from './pages/Mumbai to Pune Online Cab';
import Jogeshwaritopunecabservice from './pages/Jogeshwari to Pune Cab Service';
import Goregaontopunecab from './pages/Goregaon to Pune Cab';
import Kandivalitopunecabs from './pages/Kandivali to Pune Cab';
import Vileparletopunecabservice from './pages/Vile Parle to Pune Cab Service';
import Bhanduptopunecab from './pages/Bhandup to Pune Cab';
import Ghatkopartopunecabservice from './pages/Ghatkopar to Pune Cab Service';
import Kurlatopunetaxiservice from './pages/Kurla to Pune Taxi Service';
import Powaimumbaipunecabservice from './pages/Powai Mumbai Pune Cab Service';
import Chemburtopunecab from './pages/Chembur to Pune Cab';
import Terminalonetwothreemumbai from './pages/Terminal 1,2,3 Mumbai Airport to Pune Cab';
import Thanetopunecab from './pages/Thane to Pune Cab';
import Vikhrolitopunecabservice from './pages/Vikhroli to Pune Cab Services';
import Mumbaitopuneinnovacrysta from './pages/Mumbai to Pune Innova Crysta Cab';
import Mumbaitopimprichichwadcab from './pages/Mumbai to Pimpri Chinchwad Cab';
import Mumbaitopuneonewaycab from './pages/Mumbai to Pune One Way Cab';
import Andheritopunecabs from './pages/Andheri to Pune Cab';
import Bandratopunecab from './pages/Bandra to Pune Cab';
import Santacruztopunecab from './pages/Santacruz to Pune Cab';
import Mumbaicentraltopunecab from './pages/Mumbai Central to Pune Cab';
import Borivalitopunecab from './pages/Borivali to Pune Cab';
import Vishrantwaditomumbaicab from './pages/Vishrantwadi to Mumbai Cab';
import Alanditomumbaicabservice from './pages/Alandi to Mumbai Cabs Service';
import Boatclubroadtomumbaicab from './pages/Boat Club Road to Mumbai Cab';
import Ertigaonrentinpune from './pages/Ertiga on Rent in Pune';
import Innovacrystaoutstationpune from './pages/Innova Crysta Outstation Pune';
import Urbaniaonrentinpune from './pages/Urbania on Rent in Pune';
import Tempotravelleronrentinpune from './pages/Tempo Traveller on Rent in Pune';
import Pimprichichwadonlinecabbooking from './pages/Pimpri Chinchwad Online Cab booking';
import Bestcabserviceinpune from './pages/Best Cab Service in Pune';
import Punetomumbaionewaycabshire from './pages/Pune to Mumbai One Way Cabs hire';
import Punetonashikcabhire from './pages/Pune to Nasik Cabs hire';
import Punetomahabalehswarcabs from './pages/Pune to Mahabaleshwar Cabs';
import Punetolonavalacabbooking from './pages/Pune to Lonavala Cab Booking';
import Punetoshirdicabshire from './pages/Pune to Shirdi Cabs hire';
import Punetolavasacitycabs from './pages/Pune to Lavasa City Cabs';
import Puneairporttobhimashankarcabs from './pages/Pune Airport to Bhimashankar Cabs';
import Punetoindorecabs from './pages/Pune to Indore Cabs';
import Punetokonkandarshancabs from './pages/Pune to Konkan Darshan Cabs hire';
import Outstationcabservicepune from './pages/Outstation Cab Service Pune';
import Punetopanchganicabbooking from './pages/Pune to Panchgani Cab Booking';
import Punetonagpurcabhire from './pages/Pune to Nagpur Cab hire';
import Punetogoacabhire from './pages/Pune to Goa Cab hire';
import Punetoajantaelloracabs from './pages/Pune to Ajanta Ellora Cabs';
import Punetomumbaiurbaniaonrent from './pages/Pune to Mumbai Urbania on rent';
import Panveltomumbaiurbaniaonrent from './pages/Panvel to Pune Cab';
import Innovacrystaonrentinpune from './pages/Innova Crysta on Rent in Pune';
import Ertigacabbookinginpune from './pages/Ertiga Cab Booking in Pune';
import Puneoutstationcab from './pages/Pune Outstation Cab';
import Punetokolhpaurcab from './pages/Pune to Kolhapur Cab';
import Punetogoacabs from './pages/Pune to Goa Cab';
import Mumbaitopunecabs from './pages/Mumbai to Pune Cabs';
import Mumbaiairporttopunecab from './pages/Mumbai Airport to Pune Cab';
import Dadartopunecabs from './pages/Dadar to Pune Cab';
import Wagholitomumbaicab from './pages/Wagholi to Mumbai Cab';
import Puneoutstationcabhire from './pages/Pune Outstation Cab Hire';
import Outstationcabserviceinpune from './pages/Outstation Cab Service in Pune';
import Cabsserviceinpune from './pages/Cabs Service in Pune';
import Onlinecabbookingpune from './pages/Online Cab Booking Pune';
import Punetokonkancabservice from './pages/Pune to Konkan Cab Service';
import Punetoashtavinayakcabs from './pages/Pune to Ashtavinayak Cab';
import ContactButtons from './components/ContactButtons';
import Kolhapurtopunecabs from './pages/Kolhapur to Pune Cabs';
import Punetobangalorecab from './pages/Pune to Bangalore Cab';
import Punetogujratservice from './pages/Pune to Gujarat Cab Service';
import Punetohyderabadcabs from './pages/Pune to Hyderabad Cabs';
import Punetoahilyanagarcabs from './pages/Pune to Ahilyanagar Cabs';
import Punetosambhajinagarcabs from './pages/Pune to Sambhajinagar Cab';
import Punetodhulecabs from './pages/Pune to Dhule Cabs';
import Punetojalgaoncabs from './pages/Pune to Jalgaon Cab';
import Punetolaturcabs from './pages/Pune Latur Cabs';
import Punetomumbaidarshancabs from './pages/Pune to Mumbai Darshan Cab';
import Mumbaitoshirdireturncabs from './pages/Mumbai to Shirdi Return Cab';
import Punetosataracabs from './pages/Pune to Satara Cabs';
import Punetosanglicabs from './pages/Pune to Sangli Cabs';
import Punetosolapurcab from './pages/Pune to Solapur Cab';
import Punetotuljapurcabs from './pages/Pune to Tuljapur Cab';
import Punetoujjaincabservice from './pages/Pune to Ujjain Cab Service';
import Innovacrystacabonrentinpune from './pages/Innova Crysta Cab On Rent in Pune';
import Outstationcabbookingpune from './pages/Outstation Cab Booking Pune';
import Punetoahmednagarcab from './pages/Pune to Ahmednagar Cab';
import Punetojalnacab from './pages/Pune to Jalna Cab';
import Mumbaitoshirdicabs from './pages/Mumbai to Shirdi Cabs';
import Punetobhimashankarcab from './pages/Pune to Bhimashankar Cab';
import Puneairportcab from './pages/Pune Airport Cab';
import Punetootstationcabs from './pages/Pune to Outstation Cabs';
import Punetorajsthancab from './pages/Pune to Rajasthan Cab';
import Punetotelangana from './pages/Pune to Telangana Cab';
import Corporatecabserviceinpune from './pages/Corporate Cab Services in Pune';
import Punetoayodhyatourpackage from './pages/Pune to Ayodhya Tour Package';
import Navimumbaiairportcab from './pages/Navi Mumbai Airport Cab';
import Cheapcabserviceinpune from './pages/Cheap Cab Service in Pune';


function App() {



  return (
    <Router>
      <ScrollToTop />
      <Header />
      <ContactButtons />

      <Routes>

        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/privacy-policy" element={<PrivacyPolicySaitruptiCabs />} />
        <Route path="/term-condition" element={<TermsConditionsSaitruptiCabs />} />
        <Route path="/services" element={<ServicesSection />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/our-fleet" element={<OurFleet />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/gallery" element={<GallerySection />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/contact-us" element={<ContactDetails />} />
        <Route path="/Pune-to-Mumbai-Cab" element={<Punetomumbaicabs />} />
      









<Route path="/Pune-to-Mumbai-Airport-Cab" element={<Punetomumbaiairportcabs />} />
<Route path="/Pune-to-Mumbai-International-Airport-Cab" element={<Punetomumbaiinternatinalairport />} />
<Route path="/Pune-to-Mumbai-One-Way-Cab" element={<Punetomumbaionewaycabs />} />
<Route path="/Pune-Mumbai-Car-Hire" element={<Punemumbaicarhire />} />
<Route path="/Pune-to-Mumbai-Taxi-Fare" element={<Punetomumbaitaxifare />} />
<Route path="/Pune-to-Mumbai-Online-Cab-Booking" element={<Punetomumbaionlinecabbooking />} />
<Route path="/Pimpri-Chinchwad-to-Mumbai-Cab" element={<Pimprichichwadtomumbaicab />} />
<Route path="/Baner-to-Mumbai-Cabs" element={<Banertomumbaicabs />} />
<Route path="/Hinjewadi-to-Mumbai-Cab" element={<Hinjewaditomumbaicabs />} />
<Route path="/Pimple-Saudagar-to-Mumbai-Cab-Service" element={<Pimplesaudagartomumbai />} />
<Route path="/Wakad-to-Mumbai-Cab" element={<Wakadtomumbaicabs />} />
<Route path="/Hadapsar-to-Mumbai-Cab" element={<HAdapsartomumbaicab />} />
<Route path="/Kalyani-Nagar-to-Mumbai-Taxi" element={<Kalyaninagartomumbaitaxi />} />
<Route path="/Koregaon-Park-to-Mumbai-Cab" element={<Koregaonparktomumbaicabs />} />
<Route path="/Kothrud-to-Mumbai-Cab" element={<Kothrudtomumbaicabs />} />
<Route path="/Kharadi-to-Mumbai-Cab" element={<Kharaditomumbaicabs />} />
<Route path="/Shivajinagar-to-Mumbai-Cab" element={<Shivajinagartomumbaicabs />} />
<Route path="/Pune-to-Mumbai-Ertiga-Cab" element={<Punetomumbaiertigacabs />} />
<Route path="/Pune-to-Mumbai-Innova-Crysta-Cab" element={<Punetomumbaiinnovacrystacabs />} />
<Route path="/Pune-to-Mumbai-Sedan-Cab" element={<Punetomumbaisedancabs />} />
<Route path="/Kondhwa-to-Mumbai-Cab" element={<Kondhwatomumbaicabs />} />
<Route path="/Viman-Nagar-to-Mumbai-Cabs" element={<Vimannagartomumbaicabs />} />
<Route path="/Katraj-to-Mumbai-Cab-Service" element={<Katrajtomumbaicabservice />} />
<Route path="/Pune-Station-to-Mumbai-Cabs-Service" element={<Punestationtomumbaicabservice />} />
<Route path="/Pune-to-5-Jyotirlinga-Darshan-Cab" element={<Punetofivejyotilingadarshancabs />} />
<Route path="/Pune-to-Shirdi-Cab" element={<Punetoshirdicabs />} />
<Route path="/Pune-to-Shirdi-Cab-Fare" element={<Punetoshirdicabfare />} />
<Route path="/Pune-Airport-to-Shirdi-Cab-Service" element={<Puneairportshirdicabservice />} />
<Route path="/Pune-to-Pandharpur-Cab" element={<Punetopandharpurcab />} />
<Route path="/Pune-to-Aurangabad-Cab" element={<Punetoaurangabadcabs />} />





<Route path="/Navi-Mumbai-to-Pune-Cab" element={<Navimumbaitopunecabs />} />
<Route path="/Mumbai-Airport-to-Pune-City-Cab" element={<Mumbaiairporttopunecitycab />} />
<Route path="/Swift-Dzire-On-Rent-in-Pune" element={<Swiftdzireonrentinpune />} />
<Route path="/Mumbai-to-Pune-Daily-Cab" element={<Mumbaitopunedailycab />} />
<Route path="/Mumbai-to-Pune-Online-Cab" element={<Mumbaitopuneonlinecabs />} />
<Route path="/Jogeshwari-to-Pune-Cab-Service" element={<Jogeshwaritopunecabservice />} />
<Route path="/Goregaon-to-Pune-Cab" element={<Goregaontopunecab />} />
<Route path="/Kandivali-to-Pune-Cab" element={<Kandivalitopunecabs />} />
<Route path="/Vile-Parle-to-Pune-Cab-Service" element={<Vileparletopunecabservice />} />
<Route path="/Bhandup-to-Pune-Cab" element={<Bhanduptopunecab />} />
<Route path="/Ghatkopar-to-Pune-Cab-Service" element={<Ghatkopartopunecabservice />} />
<Route path="/Kurla-to-Pune-Taxi-Service" element={<Kurlatopunetaxiservice />} />
<Route path="/Powai-Mumbai-Pune-Cab-Service" element={<Powaimumbaipunecabservice />} />
<Route path="/Chembur-to-Pune-Cab" element={<Chemburtopunecab />} />
<Route path="/Terminal-1-2-3-Mumbai-Airport-to-Pune-Cab" element={<Terminalonetwothreemumbai />} />
<Route path="/Thane-to-Pune-Cab" element={<Thanetopunecab />} />
<Route path="/Vikhroli-to-Pune-Cab-Services" element={<Vikhrolitopunecabservice />} />
<Route path="/Mumbai-to-Pune-Innova-Crysta-Cab" element={<Mumbaitopuneinnovacrysta />} />
<Route path="/Mumbai-to-Pimpri-Chinchwad-Cab" element={<Mumbaitopimprichichwadcab />} />
<Route path="/Mumbai-to-Pune-One-Way-Cab" element={<Mumbaitopuneonewaycab />} />
<Route path="/Andheri-to-Pune-Cab" element={<Andheritopunecabs />} />
<Route path="/Bandra-to-Pune-Cab" element={<Bandratopunecab />} />
<Route path="/Santacruz-to-Pune-Cab" element={<Santacruztopunecab />} />
<Route path="/Mumbai-Central-to-Pune-Cab" element={<Mumbaicentraltopunecab />} />
<Route path="/Borivali-to-Pune-Cab" element={<Borivalitopunecab />} />
<Route path="/Vishrantwadi-to-Mumbai-Cab" element={<Vishrantwaditomumbaicab />} />
<Route path="/Alandi-to-Mumbai-Cabs-Service" element={<Alanditomumbaicabservice />} />
<Route path="/Boat-Club-Road-to-Mumbai-Cab" element={<Boatclubroadtomumbaicab />} />
<Route path="/Ertiga-on-Rent-in-Pune" element={<Ertigaonrentinpune />} />
<Route path="/Innova-Crysta-Outstation-Pune" element={<Innovacrystaoutstationpune />} />
<Route path="/Urbania-on-Rent-in-Pune" element={<Urbaniaonrentinpune />} />
<Route path="/Tempo-Traveller-on-Rent-in-Pune" element={<Tempotravelleronrentinpune />} />



<Route path="/Pimpri-Chinchwad-Online-Cab-booking" element={<Pimprichichwadonlinecabbooking />} />
<Route path="/Best-Cab-Service-in-Pune" element={<Bestcabserviceinpune />} />
<Route path="/Pune-to-Mumbai-One-Way-Cabs-hire" element={<Punetomumbaionewaycabshire />} />
<Route path="/Pune-to-Nasik-Cabs-hire" element={<Punetonashikcabhire />} />
<Route path="/Pune-to-Mahabaleshwar-Cabs" element={<Punetomahabalehswarcabs />} />
<Route path="/Pune-to-Lonavala-Cab-Booking" element={<Punetolonavalacabbooking />} />
<Route path="/Pune-to-Shirdi-Cabs-hire" element={<Punetoshirdicabshire />} />
<Route path="/Pune-to-Lavasa-City-Cabs" element={<Punetolavasacitycabs />} />
<Route path="/Pune-Airport-to-Bhimashankar-Cabs" element={<Puneairporttobhimashankarcabs />} />
<Route path="/Pune-to-Indore-Cabs" element={<Punetoindorecabs />} />
<Route path="/Pune-to-Konkan-Darshan-Cabs-hire" element={<Punetokonkandarshancabs />} />
<Route path="/Outstation-Cab-Service-Pune" element={<Outstationcabservicepune />} />
<Route path="/Pune-to-Panchgani-Cab-Booking" element={<Punetopanchganicabbooking />} />
<Route path="/Pune-to-Nagpur-Cab-hire" element={<Punetonagpurcabhire />} />
<Route path="/Pune-to-Goa-Cab-hire" element={<Punetogoacabhire />} />
<Route path="/Pune-to-Ajanta-Ellora-Cabs" element={<Punetoajantaelloracabs />} />
<Route path="/Pune-to-Mumbai-Urbania-on-rent" element={<Punetomumbaiurbaniaonrent />} />
<Route path="/Panvel-to-Pune-Cab" element={<Panveltomumbaiurbaniaonrent />} />
<Route path="/Innova-Crysta-on-Rent-in-Pune" element={<Innovacrystaonrentinpune />} />
<Route path="/Ertiga-Cab-Booking-in-Pune" element={<Ertigacabbookinginpune />} />
<Route path="/Pune-Outstation-Cab" element={<Puneoutstationcab />} />
<Route path="/Pune-to-Kolhapur-Cab" element={<Punetokolhpaurcab />} />
<Route path="/Pune-to-Goa-Cab" element={<Punetogoacabs />} />
<Route path="/Mumbai-to-Pune-Cabs" element={<Mumbaitopunecabs />} />
<Route path="/Mumbai-Airport-to-Pune-Cab" element={<Mumbaiairporttopunecab />} />
<Route path="/Dadar-to-Pune-Cab" element={<Dadartopunecabs />} />
<Route path="/Wagholi-to-Mumbai-Cab" element={<Wagholitomumbaicab />} />
<Route path="/Pune-Outstation-Cab-Hire" element={<Puneoutstationcabhire />} />
<Route path="/Outstation-Cab-Service-in-Pune" element={<Outstationcabserviceinpune />} />
<Route path="/Cabs-Service-in-Pune" element={<Cabsserviceinpune />} />
<Route path="/Online-Cab-Booking-Pune" element={<Onlinecabbookingpune />} />
<Route path="/Pune-to-Konkan-Cab-Service" element={<Punetokonkancabservice />} />
<Route path="/Pune-to-Ashtavinayak-Cab" element={<Punetoashtavinayakcabs />} />


<Route path="/Kolhapur-to-Pune-Cabs" element={<Kolhapurtopunecabs />} />
<Route path="/Pune-to-Bangalore-Cab" element={<Punetobangalorecab />} />
<Route path="/Pune-to-Gujarat-Cab-Service" element={<Punetogujratservice />} />
<Route path="/Pune-to-Hyderabad-Cabs" element={<Punetohyderabadcabs />} />
<Route path="/Pune-to-Ahilyanagar-Cabs" element={<Punetoahilyanagarcabs />} />
<Route path="/Pune-to-Sambhajinagar-Cab" element={<Punetosambhajinagarcabs />} />
<Route path="/Pune-to-Dhule-Cabs" element={<Punetodhulecabs />} />
<Route path="/Pune-to-Jalgaon-Cab" element={<Punetojalgaoncabs />} />
<Route path="/Pune-Latur-Cabs" element={<Punetolaturcabs />} />
<Route path="/Pune-to-Mumbai-Darshan-Cab" element={<Punetomumbaidarshancabs />} />
<Route path="/Mumbai-to-Shirdi-Return-Cab" element={<Mumbaitoshirdireturncabs />} />
<Route path="/Pune-to-Satara-Cabs" element={<Punetosataracabs />} />
<Route path="/Pune-to-Sangli-Cabs" element={<Punetosanglicabs />} />
<Route path="/Pune-to-Solapur-Cab" element={<Punetosolapurcab />} />
<Route path="/Pune-to-Tuljapur-Cab" element={<Punetotuljapurcabs />} />
<Route path="/Pune-to-Ujjain-Cab-Service" element={<Punetoujjaincabservice />} />
<Route path="/Innova-Crysta-Cab-On-Rent-in-Pune" element={<Innovacrystacabonrentinpune />} />
<Route path="/Outstation-Cab-Booking-Pune" element={<Outstationcabbookingpune />} />



<Route path="/Pune-to-Ahmednagar-Cab" element={<Punetoahmednagarcab />} />
<Route path="/Pune-to-Jalna-Cab" element={<Punetojalnacab />} />
<Route path="/Mumbai-to-Shirdi-Cabs" element={<Mumbaitoshirdicabs />} />
<Route path="/Pune-to-Bhimashankar-Cab" element={<Punetobhimashankarcab />} />
<Route path="/Pune-Airport-Cab" element={<Puneairportcab />} />
<Route path="/Pune-to-Outstation-Cabs" element={<Punetootstationcabs />} />
<Route path="/Pune-to-Rajasthan-Cab" element={<Punetorajsthancab />} />
<Route path="/Pune-to-Telangana-Cab" element={<Punetotelangana />} />
<Route path="/Corporate-Cab-Services-in-Pune" element={<Corporatecabserviceinpune />} />
<Route path="/Pune-to-Ayodhya-Tour-Package" element={<Punetoayodhyatourpackage />} />
<Route path="/Navi-Mumbai-Airport-Cab" element={<Navimumbaiairportcab />} />
<Route path="/Cheap-Cab-Service-in-Pune" element={<Cheapcabserviceinpune />} />

      </Routes>
      <Footer />
    </Router>


  );
}

export default App;
